import throttle from "./throttle";

const 	minHeight = 0,
		cache = [],
		elements = [],
		/** @type {HTMLElement} */ 
		footer = document.querySelector('body > footer'),
		footerHeight = footer?.offsetHeight || 0,
		startTime = Date.now();

let scrollEventBound = false;

export default () => {
	if (window.innerHeight > minHeight ) bindScrollDepth();		
};

function sendEvent(action, label, scrollDistance, timing, docHeight) {
	window.dataLayer.push({
		'event' : 'UXEvent',
		'eventCategory' : 'Page Scroll',
		'eventAction' : 'Scroll',
		'eventLabel' : window.location.pathname + ' - ' + rounded(scrollDistance).toString() + '/' + docHeight.toString(),
		'eventValue' : parseInt(label) //broken down by 25%, 50%, 75%, 100% with 100% being more lenient due to the fat footer.
	});
}

function calculateMarks(docHeight) {
	return {
		'25%' : parseInt((docHeight * 0.25).toString(), 10),
		'50%' : parseInt((docHeight * 0.50).toString(), 10),
		'75%' : parseInt((docHeight * 0.75).toString(), 10),
		// Cushion to trigger 100% event in iOS
		'100%': docHeight - footerHeight
	};
}

function checkMarks(marks, scrollDistance, timing, docHeight) {
	// Check each active mark

	Object.keys(marks).forEach(key => {
		const val = marks[key];
		if(cache.indexOf(key) === -1 && scrollDistance >= val){
			sendEvent('Percentage', key, scrollDistance, timing, docHeight);
			cache.push(key);
		}
	});
}

function rounded(scrollDistance) {
	// Returns String
	return (Math.floor(scrollDistance/250) * 250).toString();
}

function bindScrollDepth() {
	const depthCheck = throttle(() => {
		/*
		 * We calculate document and window height on each scroll event to
		 * account for dynamic DOM changes.
		 */

		var docHeight = document.body.clientHeight,
			winHeight = window.innerHeight,
			scrollDistance = window.scrollY + winHeight,

			// Recalculate percentage marks
			marks = calculateMarks(docHeight),

			// Timing
			timing = Date.now() - startTime;

		// If all marks already hit, unbind scroll event
		if (cache.length >= elements.length + 4) {
			window.removeEventListener('scroll',depthCheck);
			scrollEventBound = false;
			return;
		}

		// Check standard marks
		checkMarks(marks, scrollDistance, timing, docHeight);
	}, 500);

	scrollEventBound = true;
	window.addEventListener('scroll',depthCheck);
}